import { useSyncExternalStore } from 'react';
import { posStore, type Fix, type GpsStatus } from './posStore.js';

/**
 * Narrow selectors over the vanilla posStore. Each instrument subscribes to one
 * value so 1 Hz fixes only update that text node (spec 02).
 */
function useSelector<T>(selector: (fix: Fix | null) => T): T {
  return useSyncExternalStore(
    posStore.subscribe,
    () => selector(posStore.getState().fix),
    () => selector(null),
  );
}

export function useSog(): number | null {
  return useSelector((f) => f?.sogKn ?? null);
}

export function useCog(): number | null {
  return useSelector((f) => f?.cogDeg ?? null);
}

export function useGpsStatus(): GpsStatus {
  return useSyncExternalStore(
    posStore.subscribe,
    () => posStore.getState().status,
    () => 'idle' as GpsStatus,
  );
}
